import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import GridTitleCard from "../Cards/GridTitleCard";
import { faIdCard } from "@fortawesome/pro-solid-svg-icons";
import IDChecksGrid from "./IDChecksGrid";
import IDChecksSidePanel from "./IDChecksSidePanel";

interface IDChecksPageProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
    queryId: string;
}

interface IDChecksPageState {
    idCheckStatusId: string;
     
    serviceFilter: string;
    serviceOptions: string[];
}

class IDChecksPage extends Component<IDChecksPageProps> {
    state: IDChecksPageState;

    constructor(props: IDChecksPageProps) {
        super(props);
        this.state = {
            idCheckStatusId: "",
            serviceFilter: "",
            serviceOptions: []
        };
    }

     
    /**
     * Applies the selected filters. Status change reloads from the API;
     * the services filter is applied client-side in the grid only.
     */
    onApplyButtonClick = (idCheckStatusId: string, serviceFilter: string) => {
        this.setState({
            idCheckStatusId,
            serviceFilter
        });
    };

     
    /**
     * Receives the distinct services from the loaded grid data for the side panel filter.
     */
    onServiceOptionsLoaded = (serviceOptions: string[]) => {
        this.setState({ serviceOptions });
    };

     
    /**
     * Resolves the service type for route and hard-refresh scenarios.
     */
    getServiceTypeId = () => {
        if (this.props.location && this.props.location.state && this.props.location.state.serviceType) {
            return this.props.location.state.serviceType;
        }

        return sessionStorage.getItem("serviceTypeFilter") || "";
    };

    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixedDesktopOnly={true}>
                    <IDChecksSidePanel
                        onApplyButtonClick={this.onApplyButtonClick}
                        serviceOptions={this.state.serviceOptions}
                    />
                    <BulletinPanel />
                </SideBarTemplate>
                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <GridTitleCard title="ID Checks" icon={faIdCard} cardStyle="admin" />
                    </header>
                    <div className="row">
                        <div className="col-md">
                            <IDChecksGrid
                                idCheckStatusId={this.state.idCheckStatusId}
                                serviceTypeId={this.getServiceTypeId()}
                                serviceFilter={this.state.serviceFilter}
                                onServiceOptionsLoaded={this.onServiceOptionsLoaded}
                            />
                        </div>
                        <div></div>
                    </div>
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(IDChecksPage);
